import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableSpec } from 'src/app/services/copilot/copilot.types';

/** Rows shown in the compact inline card. */
const INLINE_ROW_LIMIT = 5;
const PEOPLE_COL = /^(person|people|member|user|name)$/i;
const PEOPLE_TITLE = /\b(people|person|member|user)s?\b/i;

/**
 * Compact inline rendering of a TableSpec in the chat bubble.
 */
@Component({
  selector: 'app-copilot-table',
  templateUrl: './copilot-table.component.html',
  styleUrls: ['./copilot-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopilotTableComponent {
  @Input() table: TableSpec | null | undefined;

  readonly inlineRowLimit = INLINE_ROW_LIMIT;

  get isPeopleTable(): boolean {
    const table = this.table;
    if (!table?.rows?.length) {
      return false;
    }
    if (PEOPLE_TITLE.test(table.id) || PEOPLE_TITLE.test(table.title ?? '')) {
      return true;
    }
    return table.columns.some(
      (col) => PEOPLE_COL.test(col.key) || PEOPLE_COL.test(col.label),
    );
  }
}
